import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const ADMIN_TOKEN_KEY = 'admin_token';
const ADMIN_USER_KEY = 'admin_user';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  // -------- 회원 앱 (phone + PIN) 인증 상태 --------
  const [token, setToken] = useState(localStorage.getItem('member_token'));
  const [member, setMember] = useState(JSON.parse(localStorage.getItem('member') || 'null'));
  const [isDefaultPin, setIsDefaultPin] = useState(localStorage.getItem('is_default_pin') === 'true');
  const [showPinWarning, setShowPinWarning] = useState(false);

  // -------- CRM 관리자 (username + password) 인증 상태 --------
  const [adminToken, setAdminToken] = useState(localStorage.getItem(ADMIN_TOKEN_KEY));
  const [admin, setAdmin] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(ADMIN_USER_KEY) || 'null');
    } catch (_) {
      return null;
    }
  });

  const login = (newToken, newMember, defaultPinFlag = false) => {
    setToken(newToken);
    setMember(newMember);
    setIsDefaultPin(defaultPinFlag);
    localStorage.setItem('member_token', newToken);
    localStorage.setItem('member', JSON.stringify(newMember));
    localStorage.setItem('is_default_pin', defaultPinFlag ? 'true' : 'false');

    const warningShown = localStorage.getItem('pin_warning_shown');
    if (defaultPinFlag && !warningShown) {
      setShowPinWarning(true);
    }
  };

  const dismissPinWarning = () => {
    setShowPinWarning(false);
    localStorage.setItem('pin_warning_shown', 'true');
  };

  const clearPinWarningFlag = () => {
    setIsDefaultPin(false);
    localStorage.setItem('is_default_pin', 'false');
    localStorage.removeItem('pin_warning_shown');
  };

  const logout = () => {
    setToken(null);
    setMember(null);
    setIsDefaultPin(false);
    setShowPinWarning(false);
    localStorage.removeItem('member_token');
    localStorage.removeItem('member');
    localStorage.removeItem('is_default_pin');
  };

  // ==== CRM 관리자 로그인/로그아웃 (회원 앱과 완전히 독립) ====
  const adminLogin = (newToken, adminUser) => {
    setAdminToken(newToken);
    setAdmin(adminUser);
    try {
      localStorage.setItem(ADMIN_TOKEN_KEY, newToken);
      localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(adminUser));
    } catch (_) {}
  };

  const adminLogout = () => {
    setAdminToken(null);
    setAdmin(null);
    try {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      localStorage.removeItem(ADMIN_USER_KEY);
    } catch (_) {}
  };

  return (
    <AuthContext.Provider
      value={{
        // 회원 앱
        token,
        member,
        login,
        logout,
        isAuthenticated: !!token,
        isDefaultPin,
        showPinWarning,
        dismissPinWarning,
        clearPinWarningFlag,
        // 관리자
        adminToken,
        admin,
        adminLogin,
        adminLogout,
        isAdminAuthenticated: !!adminToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
